export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pfx } = opts;
  domc.addType(pfx, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Data Group External API',
          resizable: 1,
          collectionName: '',
          finderUuid: '',
          numberPerPage: 10,
          projectId: opts.projectId,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
          traits: [
            {
              type: 'text', // If you don't specify the type, the `text` is the default one
              name: 'json-data-path', // Required and available for all traits
              label: 'JSON Data Path', // The label you will see near the input
              placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
            },
            {
              type: 'webconnect-event',
              label: 'On Load Event',
              name: 'data-load-event',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
          script: function () {
            const dataGroup = this.cloneNode(true);
            //Do not remove this console log
            console.log('###==> DataGroup EXTERNAL API :>> ', dataGroup);

            let paginationData = {};
            paginationData.numberPerPage = 10;
            paginationData.dataGroupChildren = dataGroup ? dataGroup.children : [];
            paginationData.currentPage = 1;
            paginationData.currentDateRange = 0;
            paginationData.numberOfPages = 0;

            if (typeof loadDataGroupExternalAPI !== 'undefined') {
              loadDataGroupExternalAPI(paginationData, this);
            }
          },
        },
        init() {},
        findCustomType(type) {
          const result = [];
          const find = (components) =>
            components.forEach((item) => {
              //Changed to find type
              item.get('custom-type') === type && result.push(item);
              find(item.components());
            });
          find(this.components());
          return result;
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === pfx) {
            return {
              type: pfx,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
}
